<template>
    <el-dialog
      title=""
      :visible.sync="$store.state.eventListObj.groupFalg"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center>
        <div class="tabs-container ng-scope">
          
          <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
              <div class="form-group  margin-0">
                <label class="col-sm-2 control-label">Event Name</label>
                <div class="col-sm-4">
                  <div>
                    <el-input
                      placeholder="Event Name"
                      v-model="searchName"
                      name="search"
                    ></el-input>
                  </div>
                </div>
                <label class="col-sm-2 control-label">Event Id</label>
                <div class="col-sm-4">
                  <div>
                    <el-input
                      placeholder="Event Id"
                      v-model="internetContentCode"
                      name="search"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="form-group margin-0">
                <label class="col-sm-2 control-label">Event Types</label>
                <div class="col-sm-4">
                  <div>
                    <el-select v-model="eventTypes" clearable >
                        <el-option 
                        v-for="item in eventTypeObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </div>
                </div>
                <label class="col-sm-2 control-label" v-if="this.$store.state.eventListObj.both">Event Group Type</label>
                <div class="col-sm-4"  v-if="this.$store.state.eventListObj.both">
                  <div>
                    <el-select v-model="eventGroupType" clearable >
                        <el-option 
                        v-for="item in eventGroupTypeObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group margin-0">
                <label class="col-sm-2 control-label">{{$t("message.Status") }}</label>
                <div class="col-sm-4">
                  <div>
                    <el-select v-model="status" disabled clearable v-bind:placeholder='$t("message.PleaseSelect")'>
                        <el-option 
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 textRight">
                  <div class>
                    <button class="btn btn btn-primary" @click="search">{{$t("message.Search") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="ibox float-e-margins">
                <div class="ibox-content">
                  <div class="row table-responsive" style="padding-bottom:60px;">
                    <div class="col-xs-12">{{total}}{{$t("message.datagridresult") }}</div>
                    <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-dblclick="handleDbClick">
                      <el-table-column type="selection" width="55" ></el-table-column>
                      <el-table-column prop="internetContentCode" label='Event ID' width="200" sortable></el-table-column>
                      <el-table-column prop="titleen_US" v-bind:label='$t("message.Title - Eng")' width="200" sortable></el-table-column>
                      <el-table-column prop="eventTypesName" v-bind:label='$t("message.Event Types")' width="170" sortable></el-table-column>
                      <el-table-column prop="eventGroupTypeName" v-bind:label='$t("message.Group Types")' width="150" ></el-table-column>
                      <el-table-column prop="statusName" v-bind:label='$t("message.Status")' width="170" sortable></el-table-column>
                      <el-table-column prop="startDate" v-bind:label='$t("message.Start Date")' width="170" sortable></el-table-column>
                      <el-table-column prop="endDate" v-bind:label='$t("message.End Date")' width="170" sortable></el-table-column>
                    </el-table>
                    <el-col :span="24" class="el-table_footertoolbar">
                      <el-pagination 
                         layout="total, sizes, prev, pager, next, jumper" 
                         @size-change="handleSizeChange" 
                         @current-change="handleCurrentChange" 
                         :page-sizes="[10, 20, 50, 100]" 
                         :page-size="pagesize" 
                         :total="total" 
                         style="float:right;">
                      </el-pagination>
                    </el-col>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.state.eventListObj.groupFalg = false">Cancel</el-button>
        <el-button type="primary" @click="addEvent">Confirm</el-button>
      </span>
    </el-dialog>
</template>
<script>
import config from "../../config";
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      sortType:"DESC",
      sortField:"id",
      searchName: "",
      eventTypes:"",
      eventGroupType:"",
      status:10,
      total:0,
      rows:[],
      multipleSelection:[],
      eventTypeObj:[],
      statusObj:[],
      internetContentCode:""
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("seteventlist", { string: "", boolean: false });
    },
    async init() {
      let obj = this.getAuthObj();
      obj.sortField = this.sortField;
      obj.sortType = this.sortType;
      obj.startRow = this.page;
      obj.maxRows = this.pagesize;
      obj.title = this.searchName;
      obj.eventTypes = this.eventTypes;
      obj.eventGroupType = this.eventGroupType;
      obj.status = this.status;
      obj.internetContentCode = this.internetContentCode;
      if(this.$store.state.eventListObj.both){
        obj.apiUrl = '/getEventAndEventGroupList'
      }else{
        obj.apiUrl = '/getEventList'
      }
      
      let data = await this.$store.dispatch("apiEvent", obj);
      if(!data) return;
      let list = null;
      for(var i=0;i<data.data.resultList.length;i++){
        for(var j=0;j<data.data.resultList[i].langMap.length;j++){
          if(data.data.resultList[i].langMap[j].langCode=="en_US"){
            data.data.resultList[i]['title'+'en_US'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['title'+'zh_HK'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['title'+'zh_CN'] = data.data.resultList[i].langMap[j].title;
          }
        }
      }
      this.total = data.data.totalRows;
      var dataList = [];
      data.data.resultList.forEach(item => {
        if(item.id!=this.$store.state.eventListObj.id){
          dataList.push(item);
        }
      })
      this.$set(this, "rows", dataList);
      this.setObj();
    },
    search() {
      this.init();
    },
    handleSizeChange:function(val){
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange:function(val){
      this.page = val-1;
      this.init();
    },
    handleSelectionChange:function(val){
      this.multipleSelection = val;
      if(this.$store.state.eventListObj.single&&val.length>1){
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(val.pop());
        // this.multipleSelection = val[val.length-1];
      }
    },
    handleDbClick:function(row){
      // this.$router.push({
      //   path: "/main/eventGroupDetail",
      //   query: { id: row.id }
      // });
    },
    sortChange:function(val){
      if(val.order=='ascending'){
        this.sortType = 'ASC';
        this.sortField = val.prop;
      }else if(val.order=="descending"){
        this.sortType = 'DESC';
        this.sortField = val.prop;
      }else{
        this.sortType = 'ASC';
        this.sortField = 'id';
      }
      this.init();
    },
    addEvent:function(){
      this.$store.state.eventListObj.callback(this.multipleSelection)
    },
    setObj:function(){
      this.eventGroupTypeObj= [{
        value: 1,
        label: this.$i18n.t("message.Series")
      }];
      this.eventTypeObj= [{
        value: '1',
        label: "Performing Arts"
      }, {
        value: '2',
        label: "Exhibitions"
      }, {
        value: '3',
        label: "Talks / Forums"
      }, {
        value: '4',
        label: "Guided Tour"
      }, {
        value: '5',
        label: "Workshops"
      }, {
        value: '6',
        label: "Screening"
      }, {
        value: '7',
        label: "Festival"
      }]
      this.statusObj=[{
        value: 0,
        label: this.$i18n.t("message.Draft")
      }, {
        value: 10,
        label: this.$i18n.t("message.Publish")
      }, {
        value: 1,
        label: this.$i18n.t("message.Unpublish")
      }]
      let list = null;
      for (list of this.rows) {
        if (list.status === 0) {
          list.statusName = this.$i18n.t("message.Draft");
        } else if (list.status == 10) {
          list.statusName = this.$i18n.t("message.Publish");
        } else if (list.status == 1) {
          list.statusName = this.$i18n.t("message.Unpublish");
        }
        if (list.eventTypes == 1) {
          list.eventTypesName = "Performing Arts"
        } else if (list.eventTypes == 2) {
          list.eventTypesName = "Exhibitions"
        } else if (list.eventTypes == 3) {
          list.eventTypesName = "Talks / Forums"
        } else if (list.eventTypes == 4) {
          list.eventTypesName = "Guided Tour"
        } else if (list.eventTypes == 5) {
          list.eventTypesName = "Workshops"
        } else if (list.eventTypes == 6) {
          list.eventTypesName = "Screening"
        } else if (list.eventTypes == 7) {
          list.eventTypesName = "Festival"
        }
        if (list.eventGroupType == 1) {
          list.eventGroupTypeName = this.$i18n.t("message.Series");
        } else if (list.eventGroupType == 2) {
          list.eventGroupTypeName = this.$i18n.t("message.Package")
        } else if (list.eventGroupType == 3) {
          list.eventGroupTypeName = this.$i18n.t("message.Festival")
        }
      }
    }
  },
  computed:{
      _obj(){
        return this.$store.state.eventListObj.groupFalg
      }
  },
  watch: {
    _obj:function(){
      if(this.$store.state.eventListObj.groupFalg){
        this.page = 0;
        this.internetContentCode = ""
        this.init();
      }
    }
  },
  mounted() {
    // this.init();
  },
};
</script>
